var _rect, _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#E8ECF3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38,
    r: 16,
    fill: "#E8ECF3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 39.5,
    r: 13.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 38C55 47.1127 47.6127 54.5 38.5 54.5C29.3873 54.5 22 47.1127 22 38M55 38C55 28.8873 47.6127 21.5 38.5 21.5M55 38H51.3333M22 38C22 28.8873 29.3873 21.5 38.5 21.5M22 38H25.6667M38.5 21.5V25.1667",
    stroke: "#272A35",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9255 35.2498C40.2791 34.6793 39.4301 34.3332 38.5002 34.3332C36.4751 34.3332 34.8335 35.9748 34.8335 37.9998C34.8335 40.0249 36.4751 41.6665 38.5002 41.6665C40.5252 41.6665 42.1668 40.0249 42.1668 37.9998C42.1668 36.9047 41.6867 35.9217 40.9255 35.2498ZM40.9255 35.2498L45.5088 30.6665",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFms);
export default __webpack_public_path__ + "static/media/icon-fms.976fa68e2fe8a45c8e4d1492d87f4486.svg";
export { ForwardRef as ReactComponent };